export const DATE_RANGE_OPTIONS = [
  { value: "today", label: "Hoy" },
  { value: "last_7_days", label: "Últimos 7 días" },
  { value: "last_30_days", label: "Últimos 30 días" },
  { value: "this_month", label: "Este mes" },
];

export const DEFAULT_DATE_RANGE = "last_30_days";

export function trackDashboardEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[dealer-dashboard-event]", eventType, metadata);
  }
}

export function formatCop(value) {
  if (value == null) return "—";
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  }).format(value);
}

export function severityClass(severity) {
  if (severity === "error") return "dashboard-alert--error";
  if (severity === "warning") return "dashboard-alert--warning";
  return "dashboard-alert--info";
}
